import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MainMenuService } from './main/services/menuservice.service';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
// import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGardService implements CanActivate {
static parameters = [Router, MainMenuService];
  constructor( private router: Router, private menuService: MainMenuService) {
    this.router = router;
    this.menuService = menuService;
  }

  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot
  // ): Observable<boolean> | Promise<boolean> | boolean {
  //   let hasAccessFlag = false;
  //   setTimeout(async ()=> {
  //     hasAccessFlag = await this.menuService.menus.some((menu) => {
  //       return menu.ROUTER_LINK === state.url;
  //     });
  //     if (!hasAccessFlag) {
  //       // Swal('Access Denied', 'You do not have access to this page', 'error');
  //       this.router.navigate(['/login']); // Redirect if no access
  //       return false;
  //     }
  //   }, 300);
  //   console.log('Access:', !hasAccessFlag);
  //   return true;
  // }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.menuService.MenuListcurrentTable.pipe(
      map(menus => {
        const hasAccessFlag = menus.some((menu: any) => menu.ROUTER_LINK === state.url);
        if (!hasAccessFlag) {
          this.router.navigate(['/login']);
        }
        console.log('Access:', hasAccessFlag);
        return hasAccessFlag;
      })
    );
  }
}
